import { Banner, Button, Col, Row, Typography } from 'darrius';

import { HowWorksData } from '../../../data/home/homeData';

import styles from './HowWorks.module.scss';

export const HowWorks = ({ buttonText = HowWorksData.buttonText }) => {
  return (
    <Banner as="section" className={`${styles['how-works']} full`}>
      <Row>
        <Col className="col-sm-12">
          <Row className="middle-sm space-top">
            <Col className="col-sm-12 col-md-2 hide-mobile">
              <img
                src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/partner-audio-and-video.svg`}
                alt="Icone de audio e vídeo"
              />
            </Col>
            <Col className="col-sm-12 col-md-5">
              <Typography.Title size="3xl">
                {HowWorksData.title}
              </Typography.Title>

              <Typography.Subtitle size="m">
                <span>{HowWorksData.descriptionFirstPart}</span>{' '}
                {HowWorksData.descriptionSecondPart}{' '}
                <span>{HowWorksData.descriptionthirdPart}</span>
              </Typography.Subtitle>

              <Button.Link
                href={HowWorksData.buttonLink}
                className="button primary default left register-for-free__button"
                type="submit"
              >
                <span>{buttonText}</span>
              </Button.Link>
            </Col>
            <Col className="col-sm-12 col-md-5 center-sm">
              <iframe
                width="420"
                height="315"
                src={HowWorksData.videoLink}
                title="Video como funciona"
              ></iframe>
            </Col>
          </Row>
        </Col>
      </Row>
    </Banner>
  );
};
